<manage-wrapper
  [backgroundColor]="'var(--normal-text)'"
  [dialogTitle]="'Manage Branding'"
  [canDuplicate]="false"
  [tabGroups]="tabGroups"
  [hideTop]="true"
  [selectedTab]="selectedTab"
  (onDone)="exit()"
  (onChangeTab)="changeTab($event)"
>
  <tip-text *ngIf="!data.onAccount" [type]="'tip'" [head]="'Tip:'" 
  [body]="'Since you are not on the account you can only select branding elements, not edit or add them'"></tip-text>
  <ng-container *ngIf="!!brandingData">
    <template-editor *ngIf="selectedTab?.id === tabs.template" 
      [account]="account" 
      [readOnly]="!data.onAccount"
      [onAccount]="data.onAccount"
      [selectedId]="brandingData.template?.id"
      (select)="select($event, 'templateId')"
      (setAsAccountDefault)="setAsAccountDefault($event, 'templateId')"
    ></template-editor>
    <brand-image-editor *ngIf="selectedTab?.id === tabs.header" 
      [account]="account" 
      [selectedId]="brandingData.header?.id"
      [accountDefaultId]="account.headerId"
      [onAccount]="data.onAccount"
      [type]="'headers'"
      (select)="select($event, 'headerId')"
      (setAsAccountDefault)="setAsAccountDefault($event, 'headerId')"
    ></brand-image-editor>
    <brand-social-editor *ngIf="selectedTab?.id === tabs.social"
      [account]="account" 
      [selectedId]="brandingData.social?.id"
      [accountDefaultId]="account.socialId"
      [onAccount]="data.onAccount"
      (select)="select($event, 'socialId')"
      (unselect)="select(null, 'socialId')"
      (setAsAccountDefault)="setAsAccountDefault($event, 'socialId')"
    ></brand-social-editor>
    <brand-footer-links-editor *ngIf="selectedTab?.id === tabs.footerLinks"
      [account]="account"
      [selectedId]="brandingData.footerLinks?.id"
      [accountDefaultId]="account.footerLinksId"
      [onAccount]="data.onAccount"
      (select)="select($event, 'footerLinksId')"
      (unselect)="select(null, 'footerLinksId')"
      (setAsAccountDefault)="setAsAccountDefault($event, 'footerLinksId')"
    ></brand-footer-links-editor>
    <brand-image-editor *ngIf="selectedTab?.id === tabs.footer" 
      [account]="account" 
      [selectedId]="brandingData.footer?.id"
      [accountDefaultId]="account.footerId"
      [onAccount]="data.onAccount"
      [type]="'footers'"
      (select)="select($event, 'footerId')"
      (setAsAccountDefault)="setAsAccountDefault($event, 'footerId')"
    ></brand-image-editor>
  </ng-container>

</manage-wrapper>

